/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureStorageAccountContainers200Response {
  'containers': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "containers",
      "baseName": "containers",
      "type": "Array<string>",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return ListAzureStorageAccountContainers200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

